import { call, put, takeLatest } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import { getInvoiceByPaymentId, getInvoices } from '../../api/invoiceApi';
import { IGetInvoicesPayload, invoiceActions } from './invoiceSlice';

function* watchGetInvoices({ payload }: { payload: IGetInvoicesPayload }) {
  try {
    yield put(invoiceActions.setComponentStatus({ getInvoicesLoading: true }));

    const response: AxiosResponse = yield call(getInvoices, payload);

    yield put(
      invoiceActions.setInvoices({
        data: response.data.data,
        count: response.data.count,
        currentPage: response.data.currentPage,
        totalPages: response.data.totalPages,
      }),
    );

    yield put(invoiceActions.setComponentStatus({ getInvoicesLoading: false }));
  } catch (error: any) {
    yield put(
      invoiceActions.setComponentStatus({
        error: error.response?.data?.message || 'Failed to fetch invoices',
        getInvoicesLoading: false,
      }),
    );
  }
}

function* watchGetInvoiceByPaymentId({ payload }: { payload: string }) {
  try {
    yield put(invoiceActions.setComponentStatus({ getInvoiceByPaymentIdLoading: true }));

    const response: AxiosResponse = yield call(getInvoiceByPaymentId, payload);

    yield put(invoiceActions.setInvoiceByPaymentId(response.data));

    yield put(invoiceActions.setComponentStatus({ getInvoiceByPaymentIdLoading: false }));
  } catch (error: any) {
    yield put(
      invoiceActions.setComponentStatus({
        error: error.response?.data?.message || 'Failed to fetch invoice by payment ID',
        getInvoiceByPaymentIdLoading: false,
      }),
    );
  }
}

function* watchDownloadInvoice({ payload }: { payload: string }) {
  try {
    yield put(invoiceActions.setComponentStatus({ downloadInvoiceLoading: true, getInvoiceByPaymentIdLoading: true }));

    const response: AxiosResponse = yield call(getInvoiceByPaymentId, payload);

    yield put(invoiceActions.setInvoiceByPaymentId(response.data));
    yield put(invoiceActions.setComponentStatus({ getInvoiceByPaymentIdLoading: false }));
  } catch (error: any) {
    yield put(
      invoiceActions.setComponentStatus({
        error: error.response?.data?.message || 'Failed to download invoice',
        downloadInvoiceLoading: false,
        getInvoiceByPaymentIdLoading: false,
      }),
    );
  }
}

export function* watchFetchInvoicesSagas() {
  yield takeLatest(invoiceActions.getInvoicesAsync, watchGetInvoices);
  yield takeLatest(invoiceActions.getInvoiceByPaymentIdAsync, watchGetInvoiceByPaymentId);
  yield takeLatest(invoiceActions.downloadInvoiceAsync, watchDownloadInvoice);
}

const invoiceSagas = watchFetchInvoicesSagas;
export default invoiceSagas;
